import React from "react";

interface CardProps {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, children, className = "" }) => (
  <div className={`card-base ${className}`}>
    <h2 className="card-title">{title}</h2>
    {children}
  </div>
);

export default Card;
